module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-search/eventsearch-reversaltransaction/eventsearch-reversaltransaction.component.css
// module id = ./src/app/components/event-search/eventsearch-reversaltransaction/eventsearch-reversaltransaction.component.css
// module chunks = main